/**
 * @group Action
@summary <blockquote>Server action operation names.</blockquote>
 * @internal
 */
export const ACTION_OPERATIONS = {
  FETCH: 'fetch operation',
  SAVE: 'save operation',
  DELETE: 'delete operation',
  CREATE: 'create operation',
  UPDATE: 'update operation',
  // Patient-specific operations
  START_CONSULTATION: 'start consultation operation',
  END_CONSULTATION: 'end consultation operation',
  CANCEL_CONSULTATION: 'cancel consultation operation',
  SET_DEFAULT_PAYMENT_METHOD: 'set default payment method operation',
  VALIDATE_PROFILE: 'validate profile operation',
  UPSERT_PROFILE: 'upsert profile operation',
} as const; 